class CustomAccordion extends HTMLElement {
    constructor() {
        super();
        this.listeners();
    }

    listeners() {
        var self = this;
        var triggers = this.querySelectorAll('[data-accordion-trigger]');
        triggers.forEach(function(trigger){
            // Click events
            trigger.addEventListener('click', function(event){
                event.preventDefault();
                self.changeActiveTab(trigger);
            });

            // Keyboard events for accessibility
            trigger.addEventListener('keydown', function(event){
                // Handle Enter and Space key presses
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    self.changeActiveTab(trigger);
                }
            });
        });
    }

    changeActiveTab(trigger) {
        var accordionItem = trigger.closest('[data-accordion-item]');
        var isCurrentlyActive = accordionItem.classList.contains('is--active');

        if (isCurrentlyActive) {
            // Collapse current panel
            accordionItem.classList.remove('is--active');
            trigger.setAttribute('aria-expanded', 'false');
        } else {
            // Collapse all panels first
            this.querySelectorAll('.is--active').forEach(function(activeItem) {
                activeItem.classList.remove('is--active');
                var activeButton = activeItem.querySelector('[data-accordion-trigger]');
                if (activeButton) {
                    activeButton.setAttribute('aria-expanded', 'false');
                }
            });
            
            // Expand clicked panel
            accordionItem.classList.add('is--active');
            trigger.setAttribute('aria-expanded', 'true');
        }
    }
}

customElements.define('custom-accordion', CustomAccordion);
